import {
   LIVECAPTIONS_USAGE,
   LIVECAPTIONS_USAGE_IDX,
   LIVECAPTIONS_TARGET_LANGUAGE,
   LIVECAPTIONS_SOURCE_LANGUAGE,
   LIVECAPTIONS_CONCURRENCY,
} from '../ZoomConstants';
import { ORGA_HASH } from '../../../constants/dataGroup';
import { format_time_Number } from '../../../util/NumberFormatter';

export const WIDGET_SETTINGS = {
   [LIVECAPTIONS_USAGE]: {
      title: (term) => 'Uptime Usage',
      urlAddon: (term) => `&zoomMetric=${term}`,
      exIndexName: LIVECAPTIONS_USAGE_IDX,
      categoryLabels: ['Whisper', 'Deepgram'],
      initialCategoryIdx: 0,
      path: 'captions/usage/timeseries',
      pathParams: '',
      columnNames: {
         uptime: 'Uptime',
      },
      formatters: (value) => format_time_Number(value),
      cellStyles: { uptime: { textAlign: 'center', verticalAlign: 'middle' } },
   },
   [LIVECAPTIONS_TARGET_LANGUAGE]: {
      title: (term) => `Target Language: ${term}`,
      urlAddon: (term) => `&zoomMetric=${term}`,
      exIndexName: LIVECAPTIONS_USAGE_IDX,
      categoryLabels: ['Uptime'],
      categoryLabelTransformFn: (label, term) => `${label} for language: '${term}'`,
      initialCategoryIdx: 0,
      path: 'captions/usage/language/target',
      pathParams: '',
      columnNames: {
         uptime: 'Uptime',
      },
      formatters: (value) => format_time_Number(value),

      cellStyles: { uptime: { textAlign: 'center', verticalAlign: 'middle' } },
   },
   [LIVECAPTIONS_SOURCE_LANGUAGE]: {
      title: (term) => `Source Language: ${term}`,
      urlAddon: (term) => `&zoomMetric=${term}`,
      exIndexName: LIVECAPTIONS_USAGE_IDX,
      categoryLabels: ['Uptime'],
      categoryLabelTransformFn: (label, term) => `${label} for language: '${term}'`,
      initialCategoryIdx: 0,
      path: 'captions/usage/language/source',
      pathParams: '',
      columnNames: {
         uptime: 'Uptime',
      },
      formatters: (value) => format_time_Number(value),
      cellStyles: { uptime: { textAlign: 'center', verticalAlign: 'middle' } },
   },
   [LIVECAPTIONS_CONCURRENCY]: {
      title: () => 'Concurrent Count',
      urlAddon: () => '',
      exIndexName: LIVECAPTIONS_USAGE_IDX,
      categoryLabels: ['Whisper', 'Deepgram'],
      initialCategoryIdx: 0,
      path: 'captions/usage/concurrency',
      pathParams: '',
      columnNames: {
         concurrency: 'Concurrent Count',
      },
      formatters: (value) => value,
      cellStyles: { concurrency: { textAlign: 'center', verticalAlign: 'middle' } },
      shownTerms: [ORGA_HASH],
   },
};
